export default function ($translate) {
    return {
        KEYS: {
            DAY: 'DAY',
            WEEK: 'WEEK',
            MONTH: 'MONTH'
        },
        LABELS: {
            DAY: $translate.instant('occurrence.days'),
            WEEK: $translate.instant('occurrence.weeks'),
            MONTH: $translate.instant('occurrence.months')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/occurrence/accessPeriodType/index.js